import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  Breadcrumbs, Card, CardActionArea, CardContent, Typography, Grid2, Box,
} from '@mui/material';
import SmartToyRoundedIcon from '@mui/icons-material/SmartToyRounded';
import StrikethroughSRoundedIcon from '@mui/icons-material/StrikethroughSRounded';
import AppShell from './components/AppShell';
import api from './services/api';

const CARD_SX = {
  elevation: 0,
  sx: {
    border: '1px solid #e0e0e0',
    borderRadius: 3,
    transition: 'box-shadow 0.2s, transform 0.2s',
    '&:hover': { boxShadow: '0 4px 20px rgba(0,0,0,0.1)', transform: 'translateY(-2px)' },
  },
};

const TextAnalysisHome = () => {
  const { surveyId } = useParams();
  const [survey, setSurvey] = useState(null);

  useEffect(() => {
    api.get(`/surveys/${surveyId}/`).then((res) => setSurvey(res.data));
  }, [surveyId]);

  if (!survey) return null;

  return (
    <AppShell>
      <Breadcrumbs separator=">" sx={{ mb: 4 }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>Home</Link>
        <Link to={`/project/${survey.project}`} style={{ textDecoration: 'none', color: 'inherit' }}>{survey.project_name}</Link>
        <Link to={`/survey/${surveyId}`} style={{ textDecoration: 'none', color: 'inherit' }}>{survey.name}</Link>
        <Typography color="textPrimary">Open Text Analysis</Typography>
      </Breadcrumbs>

      <Typography variant="h4" fontFamily="'Work Sans', sans-serif" fontWeight={700} sx={{ mb: 4 }}>
        Open Text Analysis
      </Typography>

      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
          <Card {...CARD_SX}>
            <CardActionArea component={Link} to={`/survey/${surveyId}/text-analysis/ai`} sx={{ p: 1 }}>
              <CardContent sx={{ textAlign: 'center', py: 3 }}>
                <Box sx={{ bgcolor: 'primary.light', borderRadius: 2, p: 1.5, display: 'inline-flex', mb: 1.5 }}>
                  <SmartToyRoundedIcon sx={{ fontSize: 32, color: 'primary.main' }} />
                </Box>
                <Typography variant="h6" fontFamily="'Work Sans', sans-serif" fontWeight={600}>AI Detection</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
          <Card {...CARD_SX}>
            <CardActionArea component={Link} to={`/survey/${surveyId}/text-analysis/gibberish`} sx={{ p: 1 }}>
              <CardContent sx={{ textAlign: 'center', py: 3 }}>
                <Box sx={{ bgcolor: 'primary.light', borderRadius: 2, p: 1.5, display: 'inline-flex', mb: 1.5 }}>
                  <StrikethroughSRoundedIcon sx={{ fontSize: 32, color: 'primary.main' }} />
                </Box>
                <Typography variant="h6" fontFamily="'Work Sans', sans-serif" fontWeight={600}>Gibberish Detection</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid2>
      </Grid2>
    </AppShell>
  );
};

export default TextAnalysisHome;
